import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import AfterLoggedIn from '../../components/login/AfterLoggedIn';
import MobileNavbar from '../../components/navbar/MobileNavbar';
import Review from '../Reviews/Review';
import TwitterCallback from '../mrep/TwitterCallback';

function Redirect() {
  const history = useNavigate();

  useEffect(() => {
    history(`/takes`);
  }, []);
  return <></>;
}

const MobileView = () => {
  return (
    <>
      <AfterLoggedIn>
        <MobileNavbar />
        <Routes>
          <Route path='/' element={<Review />} />
          <Route path='/takes' element={<Review />} />
          <Route path='/takes/twittertakes' element={<Review tab={1} />} />
          <Route path='/twitterCallback' element={<TwitterCallback />} />
          {/* <Route path='/eligibility' element={<EligibiltyWrapper />} /> */}
          <Route path='*' element={<Redirect />} />
        </Routes>
      </AfterLoggedIn>
    </>
  );
};

export default MobileView;
